import routes from '@/modules/partner/partner-routes';
import store from '@/modules/partner/partner-store';

export default {
  routes,
  store
};
